module.exports = {"code":"1","msg":"请求接口成功","data":{"intro":"<p>壹心理测评提醒您，在做题过程中，请注意以下几点：<br /><br />1. 测试一共<strong> 78 </strong>题，请尽量在 <strong>25 </strong>分钟内完成，否则数据可能无法保存（右上方有时间进度条）；<br /><br />2. 答案没有对错之分，如实作答即可，若遇到难以抉择的问题，请根据第一感觉作答，你的作答将得到严格保密；<br /><br />3. 如遇电话、死机等导致测试中断，可到公众号找回，系统将保留你的答题记录。</p>","name":"疫情心理修复评估","scaleId":410}}


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/getScaleIntro_id566.json
// module id = TuAd
// module chunks = 156 157